import React from 'react';
import { pxToRem } from '../util';
import ScrollingTable from './ScrollTable';
import { Space } from '@arco-design/web-react';
import CardHeader from './CardHeader';
const Box1 = (props: { charts: any }) => {
  const color = 'rgb(206, 234, 255)';
  const [data, setData] = React.useState([]);
  const tagColor = {
    重点关爱人群: '#ff7875',
    一般健康人群: '#ffc069',
    基本健康人群: '#95de64',
    待评估人群: '#8c8c8c',
  };
  const statusColor = {
    已完成: '#52c41a',
    待完成: '#fa8c16',
  };
  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      align: 'left',
      width: '32%',
      render: (_, row) => {
        return (
          <div style={{ color: color }}>
            <div style={{ fontSize: pxToRem(15) }}>{row.name}</div>
            <div
              style={{
                fontSize: pxToRem(13),
                color: 'rgba(255, 255, 255, 0.7)',
              }}
            >
              {row.itemName}
            </div>
          </div>
        );
      },
    },
    {
      title: '性别',
      dataIndex: 'gender',
      align: 'center',
      width: '10%',
      render: (_, row) => {
        if (row.gender == '男') {
          return (
            <div
              className="gender-info male-info"
              style={{
                justifyContent: 'center',
              }}
            >
              <span className="gender-icon male-icon">♂</span>
              <span className="gender-label">男</span>
            </div>
          );
        }
        return (
          <div
            className="gender-info female-info"
            style={{
              justifyContent: 'center',
            }}
          >
            <span className="gender-icon female-icon">♀</span>
            <span className="gender-label">女</span>
          </div>
        );
      },
    },
    {
      title: '年龄',
      dataIndex: 'age',
      align: 'center',
      width: '10%',
      render: (_, row) => {
        return `${row.age}岁`;
      },
    },
    {
      title: '标签',
      dataIndex: 'populationCategory',
      width: '20%',
      render: (_, row) => {
        return (
          <span
            style={{
              color: tagColor[row.populationCategory],
              fontWeight: 'bold',
            }}
          >
            {row.populationCategory}
          </span>
        );
      },
    },
    {
      title: '状态',
      dataIndex: 'itemStatus',
      align: 'right',
      width: '28%',
      cellStyle: { fontWeight: 'bold' },
      render: (_, row) => {
        return (
          <Space>
            <span>{row.expectedCompletionTime}</span>
            <span
              style={{ color: statusColor[row.itemStatus], fontWeight: 'bold' }}
            >
              {row.itemStatus}
            </span>
          </Space>
        );
      },
    },
  ];
  React.useEffect(() => {
    // 模拟数据加载
    setData(props.charts?.healthManagementTracking || []);
  }, [props.charts]);
  return (
    <div
      style={{
        background:
          'linear-gradient(0deg, rgb(21, 35, 48) 2%, rgb(17, 26, 40) 100%)',
        height: '35vh',
        padding: '5px',
        boxSizing: 'border-box',
        fontFamily: '阿里妈妈数黑体 Bold',
      }}
    >
      {/* <div
        style={{
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          fontSize: pxToRem(18),
        }}
      >
        <span>健康管理事项实时追踪</span>
        <span
          style={{
            fontSize: pxToRem(12),
            display: 'inline-block',
            padding: '1px 4px',
            color,
            width: 'fit-content',
            borderRadius: '2px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
          }}
        >
          Real-time tracking of health management matters
        </span>
      </div> */}
      <CardHeader
        title="健康管理事项实时追踪"
        subtitle="Real-time tracking of health management matters"
      />
      <div
        style={{ marginTop: pxToRem(10), height: '28vh', overflow: 'hidden' }}
      >
        <ScrollingTable
          columns={columns}
          needColumns={false}
          data={data}
          rowHeight={60}
          visibleRows={10}
          scrollInterval={2000} // 每1秒滚动一次
          style={{
            fontSize: pxToRem(14),
            // backgroundColor: 'rgba(255, 255, 255, 0.06)',
          }}
        />
      </div>
    </div>
  );
};
export default Box1;
